<div class="system-down-content">
    <div class="title">
        <img [src]="exclaimIcon" alt="Exclamation" class="exclaim-icon">
        Temporary unavailable
    </div>
    <div class="system-down-text">System is temporarily unavailable</div>
    <img [src]="systemDownIcon" alt="System Down" class="system-down-icon">
    <div class="suggestion-text">We are working to restore access as quickly as possible</div>
    <div class="actions">
      <button class="btn secondary" (click)="refreshPage()">Refresh</button>
      <button class="btn primary" (click)="logout()">Logout</button>
    </div>
</div>
